"use strict";
/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TVA_UNIT = exports.StockManagementType = exports.RPD_UNIT = exports.PricerManagementType = exports.ProduitType = exports.ConversionOperator = exports.AttributeType = void 0;
/** The type of the attribute */
var AttributeType;
(function (AttributeType) {
    AttributeType["Number"] = "number";
    AttributeType["Boolean"] = "boolean";
    AttributeType["Textarea"] = "textarea";
    AttributeType["Simpleselect"] = "simpleselect";
    AttributeType["Multiselect"] = "multiselect";
    AttributeType["Table"] = "table";
    AttributeType["Metric"] = "metric";
    AttributeType["Text"] = "text";
    AttributeType["ReferenceEntityCollection"] = "reference_entity_collection";
    AttributeType["Identifier"] = "identifier";
    AttributeType["Date"] = "date";
    AttributeType["PriceCollection"] = "price_collection";
    AttributeType["ReferenceEntity"] = "reference_entity";
})(AttributeType || (exports.AttributeType = AttributeType = {}));
/** Mathematical operator for unit conversion */
var ConversionOperator;
(function (ConversionOperator) {
    ConversionOperator["Add"] = "add";
    ConversionOperator["Sub"] = "sub";
    ConversionOperator["Mul"] = "mul";
    ConversionOperator["Div"] = "div";
})(ConversionOperator || (exports.ConversionOperator = ConversionOperator = {}));
var ProduitType;
(function (ProduitType) {
    ProduitType["PACK"] = "Pack";
    ProduitType["SINGLE"] = "SingleProduct";
})(ProduitType || (exports.ProduitType = ProduitType = {}));
var PricerManagementType;
(function (PricerManagementType) {
    PricerManagementType["PRICER"] = "pricer";
})(PricerManagementType || (exports.PricerManagementType = PricerManagementType = {}));
var RPD_UNIT;
(function (RPD_UNIT) {
    RPD_UNIT["UNIT"] = "\u20AC/unit";
    RPD_UNIT["KG"] = "\u20AC/kg";
    RPD_UNIT["L"] = "\u20AC/l";
    RPD_UNIT["T"] = "\u20AC/t";
})(RPD_UNIT || (exports.RPD_UNIT = RPD_UNIT = {}));
var StockManagementType;
(function (StockManagementType) {
    StockManagementType["STOCK_MANAGED"] = "managed";
    StockManagementType["STOCK_NOT_MANAGED"] = "notManaged";
})(StockManagementType || (exports.StockManagementType = StockManagementType = {}));
var TVA_UNIT;
(function (TVA_UNIT) {
    TVA_UNIT["POURCENT"] = "%";
})(TVA_UNIT || (exports.TVA_UNIT = TVA_UNIT = {}));
